import styled from 'styled-components';

const StyledCreateAudienceModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${props => props.theme.zindex.small};
  display: flex;
  background-color: ${props => props.theme.colors.light};
  flex-direction: column;
`;

const StyledCreateAudienceModalMain = styled.div`
  flex: 1;
  height: 100%;
  max-height: 100%;
`;

const StyledCreateAudienceModalContent = styled.div.attrs({
  id: 'gtCreateAudienceModalRow',
})`
  position: relative;
  display: flex;
  height: 100%;
  min-height: 0;
`;

const StyledCreateAudienceModalContentLeft = styled.div`
  flex: 1;
`;

const StyledCreateAudienceModalContentRight = styled.div`
  min-width: 500px;
  width: 48%;
  background-color: ${props => props.theme.colors.light_dark};
  border-left: 2px solid ${props => props.theme.colors.light_darker_1};
  position: relative;
`;

export {
  StyledCreateAudienceModal,
  StyledCreateAudienceModalMain,
  StyledCreateAudienceModalContent,
  StyledCreateAudienceModalContentLeft,
  StyledCreateAudienceModalContentRight,
};
